import React from "react"

import Layout from "../components/shared/layout"
import SEO from "../components/shared/seo"

import Hero from "../components/homepage/hero"

import Solutions from "../components/homepage/solutions"
import KeyFeatures from "../components/homepage/key-features"
import Videos from "../components/homepage/videos"
import Testimonials from "../components/homepage/testimonials"
import ClientLocations from "../components/homepage/client-locations"
import Footer from "../components/shared/footer"
import Contact from "../components/shared/contact"

import Clients from "../components/homepage/clients"
import SmartLink from "../design-system/atoms/link"

const MainPage = ({ location }) => {
  return (
    <Layout
      location={location}
      bannerText={
        <p>
          <span style={{ paddingRight: "8px" }}>🎉</span>New{" "}
          <SmartLink to="https://developer.mappedin.com/">
            Developer Portal
          </SmartLink>{" "}
          launch! Learn, experiment, and build with Mappedin SDKs{" "}
        </p>
      }
    >
      <SEO
        title="Indoor Maps and Wayfinding"
        description="Mappedin's indoor mapping software provides user-friendly, enterprise-grade tools for maintaining indoor maps and powering rich wayfinding experiences."
      />
      <Hero />
      <Solutions />
      <Clients />
      <KeyFeatures />
      <Videos />
      <Testimonials />
      <ClientLocations />
      <Contact />
      <Footer />
    </Layout>
  )
}

export default MainPage
